import { render, staticRenderFns } from "./CRUDTableCommonKPIAffectedGroups.vue?vue&type=template&id=d66072d6&scoped=true"
import script from "./CRUDTableCommonKPIAffectedGroups.vue?vue&type=script&lang=js"
export * from "./CRUDTableCommonKPIAffectedGroups.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableCommonKPIAffectedGroups.vue?vue&type=style&index=0&id=d66072d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66072d6",
  null
  
)

export default component.exports